{
  "header": {
    "nameShowStaticText": false,
    "nameVariable": {
      "id": "bf6051b3-2d0a-46c4-9eae-93740351ffe9",
      "modelUri": "http://opcfoundation.org/UA/DI/",
      "nodeId": "ns=1;i=15096",
      "displayName": "ProductInstanceUri",
      "variablePath": "<GroupIdentifier>.Identification.ProductInstanceUri",
      "dataType": "String",
      "valueRank": -1,
      "modellingRule": "Optional",
      "hasProperties": false
    },
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "7ebbfa84-cc19-4c68-a644-a5bca2f69afe",
      "modelUri": "http://opcfoundation.org/UA/DI/",
      "nodeId": "ns=1;i=15099",
      "displayName": "ComponentName",
      "variablePath": "<GroupIdentifier>.Identification.ComponentName",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification Controller",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "de3c1f26-d4a0-46f1-9ded-4a6ce0446af6",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15426",
                "displayName": "Manufacturer",
                "variablePath": "<GroupIdentifier>.Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "867a2bf4-d304-41ce-9e3e-c7f65c96b5c0",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15429",
                "displayName": "SerialNumber",
                "variablePath": "<GroupIdentifier>.Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer Uri",
              "showAsLink": false,
              "valueVariable": {
                "id": "67ec16c4-d62b-4b59-bfaf-c334ed1af918",
                "modelUri": "http://opcfoundation.org/UA/DI/",
                "nodeId": "ns=1;i=15087",
                "displayName": "ManufacturerUri",
                "variablePath": "<GroupIdentifier>.Identification.ManufacturerUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Instance Uri",
              "showAsLink": false,
              "valueVariable": {
                "id": "d770c3f2-a0cc-4c53-b572-3edf19e12770",
                "modelUri": "http://opcfoundation.org/UA/DI/",
                "nodeId": "ns=1;i=15096",
                "displayName": "ProductInstanceUri",
                "variablePath": "<GroupIdentifier>.Identification.ProductInstanceUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "59b0fb8c-eabe-42ce-b130-bc56b25b3218",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15428",
                "displayName": "Model",
                "variablePath": "<GroupIdentifier>.Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "7cd7eed8-8b3f-4871-b655-b8efa8ea609b",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6009",
                "displayName": "ProductCode",
                "variablePath": "<GroupIdentifier>.Identification.ProductCode",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ],
          "placeholderObject": "Controllers.<ControllerIdentifier>.[PLACEHOLDER]"
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Task Control Monitoring",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Task Control Name",
              "showAsLink": false,
              "valueVariable": {
                "id": "f5a5e805-92bd-4c1e-8c35-70f39cae0e34",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=18914",
                "displayName": "ComponentName",
                "variablePath": "ComponentName",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Program Name",
              "showAsLink": false,
              "valueVariable": {
                "id": "f8eecd8f-0ca3-4fa2-91a3-5b81aa37703a",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=18915",
                "displayName": "TaskProgramName",
                "variablePath": "ParameterSet.TaskProgramName",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "True"
                },
                {
                  "backgroundColor": "#ff0a0a",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "False"
                }
              ],
              "label": "Program Loaded",
              "valueVariable": {
                "id": "550399cd-104d-49c5-a4a4-36af60169be0",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=18916",
                "displayName": "TaskProgramLoaded",
                "variablePath": "ParameterSet.TaskProgramLoaded",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ],
          "placeholderObject": "Controllers.<ControllerIdentifier>.[PLACEHOLDER].TaskControls.<TaskControlIdentifier>.[PLACEHOLDER]"
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Identification Motion Device",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "5f713fbe-51c4-4eda-95ee-44eacae95de4",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15045",
                "displayName": "Manufacturer",
                "variablePath": "<GroupIdentifier>.Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "36bb9055-7caf-4b31-bfcc-7b32831023f6",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15048",
                "displayName": "SerialNumber",
                "variablePath": "<GroupIdentifier>.Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer Uri",
              "showAsLink": false,
              "valueVariable": {
                "id": "5c16deee-43f8-466a-a9a6-04586b224597",
                "modelUri": "http://opcfoundation.org/UA/DI/",
                "nodeId": "ns=1;i=15087",
                "displayName": "ManufacturerUri",
                "variablePath": "<GroupIdentifier>.Identification.ManufacturerUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Instance Uri",
              "showAsLink": false,
              "valueVariable": {
                "id": "aa0348a3-f727-4dad-9686-3cd1d49ba8f5",
                "modelUri": "http://opcfoundation.org/UA/DI/",
                "nodeId": "ns=1;i=15096",
                "displayName": "ProductInstanceUri",
                "variablePath": "<GroupIdentifier>.Identification.ProductInstanceUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "80f2ddbd-f06b-4c71-9b9c-118efa17581d",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15047",
                "displayName": "Model",
                "variablePath": "<GroupIdentifier>.Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "7cd7eed8-8b3f-4871-b655-b8efa8ea609b",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6009",
                "displayName": "ProductCode",
                "variablePath": "<GroupIdentifier>.Identification.ProductCode",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ],
          "placeholderObject": "MotionDevices.<MotionDeviceIdentifier>.[PLACEHOLDER]"
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring Motion Device",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "True"
                },
                {
                  "backgroundColor": "#ff0505",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "False"
                }
              ],
              "label": "In Control",
              "valueVariable": {
                "id": "0ac3b10e-14d2-4835-84dc-75d2aefec459",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=16364",
                "displayName": "InControl",
                "variablePath": "ParameterSet.InControl",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Speed Overide",
              "valueVariable": {
                "id": "f6a85219-9c0d-489e-9dfa-2bc567d703af",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15061",
                "displayName": "SpeedOverride",
                "variablePath": "ParameterSet.SpeedOverride",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              },
              "customRangeHigh": 100,
              "customRangeLow": 0
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "True"
                },
                {
                  "backgroundColor": "#fa0000",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "False"
                }
              ],
              "valueVariable": {
                "id": "bfbd6665-858b-46c4-8a13-c5840764a03d",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=16363",
                "displayName": "OnPath",
                "variablePath": "ParameterSet.OnPath",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              },
              "label": "On Path"
            }
          ],
          "placeholderObject": "MotionDevices.<MotionDeviceIdentifier>.[PLACEHOLDER]"
        },
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Axis Speed",
              "showAsLink": false,
              "valueVariable": {
                "id": "5f8bcc0f-42c8-48b7-9608-5503f755205a",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=16668",
                "displayName": "ActualSpeed",
                "variablePath": "ParameterSet.ActualSpeed",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Motion Profile",
              "showAsLink": false,
              "valueVariable": {
                "id": "f9eb3b29-21d5-49c9-887d-cdd1bc797f72",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15808",
                "displayName": "MotionProfile",
                "variablePath": "MotionProfile",
                "dataType": "Enum",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "OTHER",
                  "1": "ROTARY",
                  "2": "ROTARY_ENDLESS",
                  "3": "LINEAR",
                  "4": "LINEAR_ENDLESS"
                }
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Axis Position",
              "showAsLink": false,
              "valueVariable": {
                "id": "12d327c5-acd5-47d4-9d0b-bcd41090c106",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15863",
                "displayName": "ActualPosition",
                "variablePath": "ParameterSet.ActualPosition",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            }
          ],
          "placeholderObject": "MotionDevices.<MotionDeviceIdentifier>.[PLACEHOLDER].Axes.<AxisIdentifier>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "7b90e89b-2a32-4afa-9778-bfc9da6c3c62",
            "modelUri": "http://opcfoundation.org/UA/",
            "nodeId": "i=61",
            "displayName": "baseName",
            "variablePath": "baseName",
            "dataType": "String",
            "valueRank": -1,
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Safety",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Operational Mode",
              "showAsLink": false,
              "valueVariable": {
                "id": "74364260-da3e-4e0c-91c9-a65805366eb0",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15740",
                "displayName": "OperationalMode",
                "variablePath": "ParameterSet.OperationalMode",
                "dataType": "Enum",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "OTHER",
                  "1": "MANUAL_REDUCED_SPEED",
                  "2": "MANUAL_HIGH_SPEED",
                  "3": "AUTOMATIC",
                  "4": "AUTOMATIC_EXTERNAL"
                }
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "STOP"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": " "
                }
              ],
              "label": "Emergency Stop",
              "valueVariable": {
                "id": "86cd1270-0899-46a7-93d9-dbfd03c84f25",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15741",
                "displayName": "EmergencyStop",
                "variablePath": "ParameterSet.EmergencyStop",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "STOP"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": " "
                }
              ],
              "label": "Protective Stop",
              "valueVariable": {
                "id": "375310e7-c854-4e3c-af50-6811f3f09825",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15742",
                "displayName": "ProtectiveStop",
                "variablePath": "ParameterSet.ProtectiveStop",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ],
          "placeholderObject": "SafetyStates.<SafetyStateIdentifier>.[PLACEHOLDER]"
        }
      ]
    }
  ]
}
